// src/theme/fonts.ts
var fontFaceDeclarations = [
  {
    "@font-face": {
      fontFamily: "SuisseIntl-Regular",
      src: "url('https://web-assets.stockx.com/fonts/SuisseIntl-Regular-WebM.woff2') format('woff')",
      fontDisplay: "swap"
    }
  },
  {
    "@font-face": {
      fontFamily: "SuisseIntl-Medium",
      src: "url('https://web-assets.stockx.com/fonts/SuisseIntl-Medium-WebM.woff2') format('woff')",
      fontDisplay: "swap"
    }
  },
  {
    "@font-face": {
      fontFamily: "SuisseIntl-Bold",
      src: "url('https://web-assets.stockx.com/fonts/SuisseIntl-Bold-WebM.woff2') format('woff')",
      fontDisplay: "swap"
    }
  },
  {
    "@font-face": {
      fontFamily: "GesturaText-Regular",
      src: "url('https://web-assets.stockx.com/fonts/GesturaText-Regular.woff2') format('woff')",
      fontDisplay: "swap"
    }
  }
];
var fontFaceProps = {
  body: '"SuisseIntl-Regular", sans-serif',
  suisseIntlRegular: '"SuisseIntl-Regular", sans-serif',
  suisseIntlMedium: '"SuisseIntl-Medium", sans-serif',
  suisseIntlBold: '"SuisseIntl-Bold", sans-serif',
  gesturaTextRegular: '"GesturaText-Regular", serif'
};
var fontSizes = {
  xs: "0.75rem",
  // 12px
  sm: "0.875rem",
  // 14px
  md: "1rem",
  // 16px
  lg: "1.125rem",
  // 18px
  xl: "1.25rem",
  // 20px
  "2xl": "clamp(22px, calc(0.1877934272vw + 21.2957746479px), 24px)",
  // responsive range between 22-24px
  "3xl": "clamp(24px, calc(0.7407407407vw + 21.3333333333px), 32px)",
  // responsive range between 24-32px
  "4xl": "clamp(26px, calc(1.2962962963vw + 21.3333333333px), 40px)",
  // responsive range between 26-40px
  "5xl": "clamp(28px, calc(1.8518518519vw + 21.3333333333px), 48px)",
  // responsive range between 28-48px
  "6xl": "clamp(30px, calc(2.4074074074vw + 21.3333333333px), 56px)",
  // responsive range between 30-56px
  // static sizes:
  "2xl-static": "1.5rem",
  // 24px
  "3xl-static": "2rem",
  // 32px
  "4xl-static": "2.5rem",
  // 40px
  "5xl-static": "3rem",
  // 48px
  "6xl-static": "3.5rem"
  // 56px
};
var lineHeights = {
  xs: 1.5,
  sm: 1.42857,
  md: 1.375,
  lg: 1.333,
  xl: 1.3,
  "2xl": 1.25,
  "3xl": 1.28,
  "4xl": 1.25,
  "5xl": 1.25,
  "6xl": 1.2
};
var bodyLetterSpacing = "0.004rem";

export {
  fontFaceDeclarations,
  fontFaceProps,
  fontSizes,
  lineHeights,
  bodyLetterSpacing
};
